import { SORT_TYPE } from 'shared/constants/sort';

function calculateSortValue(previousValue: SORT_TYPE): SORT_TYPE {
    return previousValue === SORT_TYPE.DESC ? SORT_TYPE.ASC : SORT_TYPE.DESC;
}
export { calculateSortValue };
